var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"uk-input",attrs:{"type":"number","disabled":_vm.field.generated == true || (_vm.field.editable == false && (_vm.content !== null))},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }